import React from 'react';
import { range } from 'lodash';
import { FormCheck, FormSelect } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { show as showLoad } from './skillLoadSlice';
import { show as showSave } from './skillSaveSlice';
import { show as showShare } from './skillShareSlice';
import { reset, setStrn, setIntl, setWilp, setDext, setCont, setRaceId, setProfessionId, setBonded, getTrainerResults, setOptimized } from './skillTrainerSlice';

const strnOptions = range(9, 21 + 1);
const intlOptions = range(3, 19 + 1);
const wilpOptions = range(3, 19 + 1);
const dextOptions = range(9, 19 + 1);
const contOptions = range(9, 19 + 1);

function SkillTrainerHeader() {
  const dispatch = useAppDispatch();
  const strn = useAppSelector(state => state.skillTrainer.strn);
  const intl = useAppSelector(state => state.skillTrainer.intl);
  const wilp = useAppSelector(state => state.skillTrainer.wilp);
  const dext = useAppSelector(state => state.skillTrainer.dext);
  const cont = useAppSelector(state => state.skillTrainer.cont);
  const raceId = useAppSelector(state => state.skillTrainer.raceId);
  const raceOptions = useAppSelector(state => state.skillTrainer.raceOptions);
  const professionId = useAppSelector(state => state.skillTrainer.professionId);
  const professionOptions = useAppSelector(state => state.skillTrainer.professionOptions);
  const bonded = useAppSelector(state => state.skillTrainer.bonded);
  const bondedEnabled = useAppSelector(state => state.skillTrainer.bondedEnabled);
  const optimized = useAppSelector(state => state.skillTrainer.optimized);

  const handleOptimizedChange = (value: boolean) =>  {
    dispatch(setOptimized(value));
    dispatch(getTrainerResults());
  }

  const handleStrnChange = (value: string) =>  {
    dispatch(setStrn(parseInt(value)));
    dispatch(getTrainerResults());
  }

  const handleIntlChange = (value: string) =>  {
    dispatch(setIntl(parseInt(value)));
    dispatch(getTrainerResults());
  }

  const handleWilpChange = (value: string) =>  {
    dispatch(setWilp(parseInt(value)));
    dispatch(getTrainerResults());
  }

  const handleDextChange = (value: string) =>  {
    dispatch(setDext(parseInt(value)));
    dispatch(getTrainerResults());
  }
  
  const handleContChange = (value: string) =>  {
    dispatch(setCont(parseInt(value)));
    dispatch(getTrainerResults());
  }

  const handleRaceChange = (race: string) => {
    dispatch(setRaceId(race));
    dispatch(getTrainerResults());
  }

  const handleProfessionChange = (profession: string) => {
    dispatch(setProfessionId(profession));
    dispatch(getTrainerResults());
  }

  const handleBondedChange = (bonded: boolean) => {
    dispatch(setBonded(bonded));
    dispatch(getTrainerResults());
  }

  return (
    <div className="weave-trainer-header">      
      <div className="me-2">
        <label className="small">Race</label>
        <FormSelect className="race" size="sm" aria-label="Race" value={raceId} onChange={e => handleRaceChange(e.target.value)}>
          {raceOptions.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
        </FormSelect>
      </div>

      <div className="me-2">
        <label className="small">Class</label>
        <FormSelect className="profession" size="sm" aria-label="Class" value={professionId} onChange={e => handleProfessionChange(e.target.value)}>
          {professionOptions.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
        </FormSelect>
      </div>

      <div className="me-2">
        <div className="d-flex align-items-center flex-wrap">
          <div className="me-2">
            <label className="small">Str</label>
            <FormSelect className="w-auto" size="sm" aria-label="Strength" value={strn} onChange={e => handleStrnChange(e.target.value)}>
              {strnOptions.map(x => <option key={x} value={x}>{x}</option>)}
            </FormSelect>
          </div>
          <div className="me-2">
            <label className="small">Int</label>
            <FormSelect className="w-auto" size="sm" aria-label="Intelligence" value={intl} onChange={e => handleIntlChange(e.target.value)}>
              {intlOptions.map(x => <option key={x} value={x}>{x}</option>)}
            </FormSelect>
          </div>
          <div className="me-2">
            <label className="small">Wil</label>
            <FormSelect className="w-auto" size="sm" aria-label="Willpower" value={wilp} onChange={e => handleWilpChange(e.target.value)}>
              {wilpOptions.map(x => <option key={x} value={x}>{x}</option>)}
            </FormSelect>
          </div>
          <div className="me-2">
            <label className="small">Dex</label>
            <FormSelect className="w-auto" size="sm" aria-label="Dexterity" value={dext} onChange={e => handleDextChange(e.target.value)}>
              {dextOptions.map(x => <option key={x} value={x}>{x}</option>)}
            </FormSelect>
          </div>
          <div className="me-2">
            <label className="small">Con</label>
            <FormSelect className="w-auto" size="sm" aria-label="Constitution" value={cont} onChange={e => handleContChange(e.target.value)}>
              {contOptions.map(x => <option key={x} value={x}>{x}</option>)}
            </FormSelect>
          </div>
          <div className="me-2 text-center">
            <label className="small ms-0">Bonded</label>
            <FormCheck type="switch" className="my-switch" checked={bonded} onChange={e => handleBondedChange(e.target.checked)} disabled={!bondedEnabled} />
          </div>
        </div>
      </div>

      <div className="header-spacer me-2">
        <Button className="me-2" size="sm" variant="primary" onClick={() => dispatch(reset())}>Reset</Button>
        <Button className="me-2" size="sm" variant="primary" onClick={() => dispatch(showSave())}>Save</Button>
        <Button className="me-2" size="sm" variant="primary" onClick={() => dispatch(showLoad())}>Load</Button>
        <Button className="me-0" size="sm" variant="primary" onClick={() => dispatch(showShare())}>Share</Button>
      </div>

      <div className="ms-lg-auto text-center">
        <label className="small ms-0">Beta</label>
        <FormCheck type="switch" className="my-switch" checked={optimized} onChange={e => handleOptimizedChange(e.target.checked)} />
      </div>
    </div>
  );
}

export default SkillTrainerHeader;